import { __assign, __decorate, __extends, __rest } from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { BindPropsHelper, CheckboxType } from '../PropTypes';
import { Validation, Utils } from '@singularsystems/neo-core';
import ComponentBase from '../ComponentBase';
import { EditorParentType, FormContext } from '../FormContext';
var FormGroupBase = /** @class */ (function (_super) {
    __extends(FormGroupBase, _super);
    function FormGroupBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupBase.prototype.getFormGroupClasses = function (domProps, isCheckBox) {
        return { containerDom: domProps, container: "form-group", label: "", editor: "" };
    };
    FormGroupBase.prototype.hideLabelForCheckboxes = function () {
        return true;
    };
    FormGroupBase.prototype.render = function () {
        var _a;
        var allProps = BindPropsHelper.normaliseContainerProps(this, this.props, true);
        var containerProps = allProps.container;
        var _b = allProps.containerDom, labelProps = _b.labelProps, suppressLabel = _b.suppressLabel, footerText = _b.footerText, rightLabel = _b.rightLabel, domProps = __rest(_b, ["labelProps", "suppressLabel", "footerText", "rightLabel"]);
        var checkBoxType = BindPropsHelper.getCheckBoxType(allProps);
        // Get the classes for the container, label and editor. InlineForm overrides this.
        var classes = this.getFormGroupClasses(domProps, checkBoxType !== CheckboxType.None);
        var labelText = containerProps.label ? containerProps.label : allProps.bind.propertyInfo.readableName;
        var displayInfo = allProps.bind.validator.getDisplayState(allProps.fileProps ? Validation.DisplayMode.Always : this.context.validationDisplayMode);
        var showValidation = displayInfo.severity != Validation.RuleSeverity.None;
        var className = Utils.joinWithSpaces(classes.containerDom.className, classes.container);
        var labelClassName = Utils.joinWithSpaces(labelProps && labelProps.className, classes.label);
        if (checkBoxType !== CheckboxType.None) {
            if (!allProps.input) {
                allProps.input = {};
            }
            if (this.hideLabelForCheckboxes()) {
                // Hide this label here, and pass label text to child input component.
                if (!suppressLabel && allProps.input.label === undefined) {
                    allProps.input.label = labelText;
                }
                suppressLabel = true;
            }
        }
        var label;
        if (!((_a = this.context.suppressLabels) !== null && _a !== void 0 ? _a : suppressLabel)) {
            label = React.createElement("label", __assign({}, labelProps, { htmlFor: allProps.uniqueID, className: labelClassName }),
                labelText,
                " ");
            if (rightLabel) {
                label = React.createElement("div", { className: "form-group-label" },
                    label,
                    rightLabel);
            }
        }
        var editor = containerProps.suppressDefaultContent ? undefined : BindPropsHelper.getFormControl(allProps);
        return (React.createElement("div", __assign({}, classes.containerDom, { className: className }),
            label,
            React.createElement("div", { className: classes.editor },
                !containerProps.suppressDefaultContent && editor,
                !containerProps.bindContext && this.props.children,
                containerProps.bindContext &&
                    React.createElement(FormContext.Provider, { value: __assign(__assign({}, this.context), { parentType: EditorParentType.FormGroup, bindProperty: containerProps.bindContext, uniqueId: allProps.uniqueID }) }, this.props.children),
                showValidation &&
                    React.createElement("div", { className: "invalid-feedback " + displayInfo.additionalClassName, style: { display: "block" } },
                        displayInfo.severity == Validation.RuleSeverity.AsyncBusy && React.createElement("span", { className: "spinner-grow" }),
                        React.createElement("span", null, displayInfo.displayText)),
                !showValidation && footerText &&
                    React.createElement("small", { className: "form-text text-muted" }, footerText))));
    };
    FormGroupBase.contextType = FormContext;
    return FormGroupBase;
}(ComponentBase));
export { FormGroupBase };
var FormGroup = /** @class */ (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroup = __decorate([
        observer
    ], FormGroup);
    return FormGroup;
}(FormGroupBase));
export default FormGroup;
